/* eslint-disable no-script-url */

import React from 'react';
import Link from '@material-ui/core/Link';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';

import { getCtasTercero } from '../../actions/getCtasTercero';
import { loadingTerceroCuentas, openConfirmSnackBar, resetTerceroCuentas, initPost } from '../../actions'

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';

import IconButton from '@material-ui/core/IconButton';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import GpsFixedOutlined from '@material-ui/icons/GpsFixedOutlined';
import Refresh from '@material-ui/icons/Refresh';

import { store } from '../../store';


import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';

import { connect } from 'react-redux';

// Generate Order Data
function createData(resp, facturaNo, cuenta, doc, nombre, telefono, correo, saldo) {
    return { resp, facturaNo, cuenta, doc, nombre, telefono, correo, saldo };
}

const cargarDatos = (props) => {

    var urlParams = "";
    urlParams += "/" + encodeURIComponent(props.terceroID);

    const info = props.getCtasTercero(urlParams);
    store.dispatch(loadingTerceroCuentas());
    //debugger;
    return info;
};

//const tabla = props => {
//const { classes } = props



const handleClose = (cta, props) => {
    //alert("vuamos con :" + cta + "u:" + 

    store.dispatch(openConfirmSnackBar(cta));
}


const tabla = props => {

    const { classes } = props

    const lstCuentas = props.terceroCuentas.cta

    const rows = [
        //createData(props.cuenta.resp, props.cuenta.facturaNo, props.cuenta.cuenta, props.cuenta.doc, props.cuenta.nombre, props.cuenta.telefono, props.cuenta.correo, saldo),
        createData(1, '16 Mar, 2019', 'Paul McCartney', 'London, UK', 'VISA ⠀•••• 2574', 866.99),
    ];

    return (
        <Paper className={classes.paper}>


            <React.Fragment>

                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Cuenta</TableCell>
                            <TableCell>Ult. Fact.</TableCell>
                            <TableCell>C.C. o Nit</TableCell>
                            <TableCell>Cliente</TableCell>

                            <TableCell align="right">Saldo</TableCell>
                            <TableCell></TableCell>
                            <TableCell>GPS</TableCell>
                            {props.rolID === 1 ? <TableCell>
                            </TableCell> : <TableCell></TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {lstCuentas.map(row => (
                            <TableRow key={row.cuentaCodigo}>
                                <TableCell>{row.cuentaCodigo}</TableCell>
                                <TableCell>{row.cuentaFactura}</TableCell>
                                <TableCell>{row.cuentaDoc}</TableCell>
                                <TableCell>{row.cuentaCliente}</TableCell>

                                <TableCell align="right">{Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(row.cuentaSaldo)}</TableCell>
                                <TableCell>
                                    <IconButton
                                        key="borrarCta"
                                        aria-label="close"
                                        color="inherit"
                                        className={classes.close}
                                        onClick={() => { handleClose('Está seguro(a) de quitar la cuenta: ' + row.cuentaCodigo + ',quitarCuenta,' + row.cuentaCodigo + ',' + row.terceroID, props) }}>
                                        <DeleteOutline />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => window.open("https://www.google.com/maps/dir//" + row.cuentaGPS, "_blank")}
                                        key="goGps"
                                        aria-label="close"
                                        color="inherit"
                                        className={classes.close}>
                                        <GpsFixedOutlined />
                                    </IconButton>
                                </TableCell>
                                {props.rolID === 1 ? <TableCell>
                                    <IconButton
                                        key="actualizarCta"
                                        aria-label="close"
                                        color="inherit"
                                        className={classes.close}
                                        onClick={() => { handleClose('Está seguro(a) de recargar los datos de la cuenta: ' + row.cuentaCodigo + ',actualizarCta,' + row.cuentaCodigo + ',' + row.terceroID, props) }}>
                                        <Refresh />
                                    </IconButton>
                                </TableCell> : <TableCell></TableCell>}

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </React.Fragment>
        </Paper>
    );
};

/*
 <TableCell>Teléfono</TableCell>
 <TableCell>E-Mail</TableCell>

  <TableCell>{row.cuentaTel}</TableCell>
<TableCell>{row.cuentaMail}</TableCell>

*/

const mostrarCargando = props => {
    const { classes } = props;

    if (props.terceroCuentas.resp !== "loading") {
        cargarDatos(props);
    }

    return (
        <div>  <CircularProgress className={classes.progress} /></div>);
}

const FrmTerceroCuentas = props => {
    const { classes } = props;

    const msg = props.apiFetch.postData === undefined ? 'init' : props.apiFetch.postData.msg;

    if (msg === "Datos de la cuenta actualizados satisfactoriamente...") {
        console.log(props.apiFetch.postData.msg);
        store.dispatch(initPost());
        store.dispatch(resetTerceroCuentas());
        //debugger;

    }


    if (msg === "Cuenta quitada satisfactoriamente...") {
        console.log(props.apiFetch.postData.msg);
        store.dispatch(initPost());
        store.dispatch(resetTerceroCuentas());
        //debugger;
    }

    return (

        props.terceroCuentas.resp === "ok" ? tabla(props, classes) : mostrarCargando(props, classes)

    );
};

const mapStateToProps = function (state) {
    return {
        terceroCuentas: state.terceroCuentas,
        terceroID: state.auth.terceroID,
        rolID: state.auth.rolID,
        apiFetch: state.apiFetch,
    }
}


export default connect(mapStateToProps, { getCtasTercero })(FrmTerceroCuentas);


//<AddCircleOutline className={clsx(classes.leftIcon, classes.iconSmall)} />